module.exports = __webpack_public_path__ + "media/images/free-drink-888e0dda8f6ab59c03280b68186dad79.png";